import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Row } from 'Components/UI'

export const Container = styled(Flex)`
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: ${themeGet('colors.bg.white')};

  color: ${themeGet('colors.white')};
`

export const Content = styled(Flex).attrs({
  flexDirection: 'column',
  width: 1,
})`
  align-items: center;
  justify-content: center;
`

export const ImageHolder = styled(Row).attrs({
  width: [1, 550],
})`
  img {
    width: 100%;
    position: relative;
  }
`
